<div fxFlexFill fxLayout="column">
    <h1 mat-dialog-title fxFlex>Today's Alert</h1>
    <div *ngIf="alert" class="alert-message" fxFlex mat-dialog-content fxLayout="column">
        <span fxFlex>
         {{ alert.message }}
        </span>
    </div>
    <div mat-dialog-actions fxLayout="row" fxFlex>
        <div fxFlex="20%"></div>
        <div fxFlex="80%" fxLayout="row" fxLayoutGap="8px">
            <button mat-raised-button fxFlex="70%" color="primary" fxLayoutAlign="center end" mat-dialog-close (click)="open()">Read More</button>
            <button mat-raised-button fxFlex="30%" color="secondary" fxLayoutAlign="center end" mat-dialog-close (click)="close()">Close</button>
        </div>
    </div>
</div>